import { CplRequestQfm } from './cpl-request-qfm.model';
import { CplRequestBasicData } from './cpl-request-basic-data.model';

export class CplRequestDuplicateData{
    BasicData: CplRequestBasicData;
    Qfms: CplRequestQfm[];
}